// r2/shopify_build/theme/assets/countdown.js — CC-02
// Drives every <div class="gl-countdown" data-gl-countdown="ISO8601">…</div>
// ticking every second until the target time. After release, the element
// hides itself.
(function () {
  function tick(el) {
    var target = new Date(el.dataset.glCountdown).getTime();
    if (Number.isNaN(target)) { el.style.display = 'none'; return; }
    var now = Date.now();
    var delta = Math.max(0, Math.floor((target - now) / 1000));
    if (delta === 0) { el.style.display = 'none'; return; }
    var d = Math.floor(delta / 86400);
    var h = Math.floor((delta % 86400) / 3600);
    var m = Math.floor((delta % 3600) / 60);
    var s = delta % 60;
    el.querySelector('[data-unit="days"]').textContent    = String(d).padStart(2, '0');
    el.querySelector('[data-unit="hours"]').textContent   = String(h).padStart(2, '0');
    el.querySelector('[data-unit="minutes"]').textContent = String(m).padStart(2, '0');
    el.querySelector('[data-unit="seconds"]').textContent = String(s).padStart(2, '0');
  }
  function init() {
    var els = document.querySelectorAll('.gl-countdown[data-gl-countdown]');
    if (!els.length) return;
    els.forEach(tick);
    setInterval(function () { els.forEach(tick); }, 1000);
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
